import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/esm/Button";
import { useEffect, useState } from "react";

function CalcHeader({ tftInfo }) {
  const [marginTop, setMarginTop] = useState("mt-3");
  useEffect(() => {
    if (tftInfo === null) {
      setMarginTop("mt-3");
    } else {
      setMarginTop("mt-0");
    }
  }, [tftInfo]);
  return (
    <div className="text-center">
      <Row className={`justify-content-center ${marginTop}`}>
        <Col xl={12} lg={12} md={12} sm={12}>
          <Alert
            style={{ display: "inline-block" }}
            className="bkgrnd-rg-gray"
            key="chooseRightAlert"
          >
            This tire fill tool is provided by Rim Guard to assist our dealers
            in creating quick estimates for sales quotes. The recommended tire
            fill amounts for the exact same tire size can vary depending on the
            equipment the tire will be installed on as well as the tire
            manufacturer. Rim Guard always recommends filling the tire based
            upon the hydroinflation chart in the tire manufacturer's data book.
          </Alert>
        </Col>
        <Button
          href="https://25hocqqai9f40uz013vrrbx1-wpengine.netdna-ssl.com/wp-content/uploads/2020/04/RimGuardBeetJuiceTireFillChart.pdf"
          className="mb-3 btn-rg-purple"
        >
          View our printable Tire Fill Chart
        </Button>
      </Row>
    </div>
  );
}

export default CalcHeader;
